import { Link } from "react-router-dom";
import styled from "styled-components";
import hamburger from "../img/ikony/hamburger.svg";
import AnimateHeight from "react-animate-height";
import { useState } from "react";

const Navigation = styled.nav`
  height: 12vh;
  width: 100%;
  display: flex;
  background-color: #2e1919;
  position: sticky;
  top: 0;
  z-index: 5;
`;

const Logo = styled.header`
  height: 100%;
  width: 20%;

  @media only screen and (max-width: 1280px) {
    width: 30%;
  }
  @media only screen and (max-width: 800px) {
    width: 45%;
  }
  @media only screen and (max-width: 600px) {
    width: 70%;
  }
`;
const Brother = styled(Link)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > h1 {
    margin-left: 1vw;
    color: #798460;
    font-size: 6vh;
    font-weight: 300;
    user-select: none;
  }
  & > svg {
    height: 60px;
    width: auto;
    stroke: #537fe7;
  }
  @media only screen and (max-width: 800px) {
    & > svg {
      height: 50px;
    }
  }
`;

const Belt = styled.nav`
  height: 100%;
  width: 80%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 1.25rem;

  @media only screen and (max-width: 1280px) {
    width: 70%;
  }
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;
const Button = styled.div`
  display: flex;
  color: #f8ffe8;
  text-decoration: none !important;
  align-items: center;
  justify-content: center;
  background-color: #798460;
  width: 12vw;
  height: 8vh;
  user-select: none;
  border-bottom: #fff;
  transition: 0.3s;
  cursor: pointer;
  text-align: center;
  border-radius: 2vh;

  &:hover {
    transform: scale(0.85);
  }
  @media only screen and (max-width: 1165px) {
    width: 15vw;
  }
  @media only screen and (max-width: 800px) {
    width: 100%;
    height: 6vh;
    background-color: rgba(0, 0, 0, 0);

    border-radius: 0;
    &:hover {
      & > p {
        text-decoration: underline;
      }
      transform: none;
    }
  }
`;
const Animacja = styled(AnimateHeight)`
  width: 100%;
  height: 100%;

  display: flex;

  flex-direction: column;
  font-size: 1.25rem;
  background-color: rgba(0, 0, 0, 0.7);
  margin-top: 12vh;
`;
const Linkii = styled(Link)`
  width: auto;
  height: auto;
`;
const TelefonNav = styled.nav`
  height: 100%;
  width: 55%;
  display: none;

  & > img {
    position: absolute;
    top: 1vh;
    right: 5vw;
    height: 10vh;
    width: 10vh;
  }
  @media only screen and (max-width: 800px) {
    display: block;
  }
  @media only screen and (max-width: 600px) {
    width: 100vw;
    position: absolute;
    left: 0;
  }
`;
function Nav() {
  function redHolder(x) {
    var count = document.getElementById("TF").children.length;

    for (var i = 1; i < count + 1; i++) {
      document.querySelector("#navPrzycisk" + i).style.backgroundColor =
        "#798460";
    }
    document.querySelector("#navPrzycisk" + x).style.backgroundColor =
      "#5B2632";
  }

  const [heighter, heightSet] = useState(0);
  function heightHolder() {
    heightSet(heighter === 0 ? "200%" : 0);
  }

  var logo = (
    <svg
      version="1.1"
      viewBox="0 0 127.41 208.84"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-41.295 -44.08)">
        <g
          transform="matrix(3.0636 0 0 3.0636 -174.04 -144.75)"
          stroke="#798460"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        >
          <path
            d="m91.082 63.867a18.562 18.562 0 0 0-18.563 18.563 18.562 18.562 0 0 0 0.0186 0.47181h37.088a18.562 18.562 0 0 0 0.0186-0.47181 18.562 18.562 0 0 0-18.562-18.563z"
            fill="none"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m91.079 127.57a18.562 18.562 0 0 1-18.563-18.563 18.562 18.562 0 0 1 0.0186-0.47181h37.088a18.562 18.562 0 0 1 0.0186 0.47181 18.562 18.562 0 0 1-18.562 18.563z"
            fill="none"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m72.593 82.922 37.022 25.612z"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m109.62 82.922-37.022 25.612z"
            style={{ paintOrder: "normal" }}
          />
        </g>
      </g>
    </svg>
  );

  return (
    <Navigation>
      <Logo>
        <Brother to="/">
          {logo}
          <h1>Szota.pl</h1>
        </Brother>
      </Logo>
      <TelefonNav>
        <img onClick={heightHolder} src={hamburger} alt="error" />
        <Animacja id="navControls" duration={500} height={heighter}>
          <Linkii to="/">
            <Button onClick={heightHolder}>
              <p>Strona główna</p>
            </Button>
          </Linkii>
          <Linkii to="/whoami">
            <Button onClick={heightHolder}>
              <p>O mnie</p>
            </Button>
          </Linkii>
          <Linkii to="/portfolio">
            <Button onClick={heightHolder}>
              <p>Portfolio</p>
            </Button>
          </Linkii>
          <Linkii onClick={heightHolder} to="/kontakt">
            <Button>
              <p>Kontakt</p>
            </Button>
          </Linkii>
        </Animacja>
      </TelefonNav>
      <Belt id="TF">
        <Linkii
          to="/"
          onClick={() => {
            redHolder(1);
          }}
        >
          <Button id="navPrzycisk1">Home</Button>
        </Linkii>
        <Linkii
          to="/whoami"
          onClick={() => {
            redHolder(2);
          }}
        >
          <Button id="navPrzycisk2">O mnie</Button>
        </Linkii>
        <Linkii
          to="/portfolio"
          onClick={() => {
            redHolder(3);
          }}
        >
          <Button id="navPrzycisk3">Portfolio</Button>
        </Linkii>
        <Linkii
          to="/kontakt"
          onClick={() => {
            redHolder(4);
          }}
        >
          <Button id="navPrzycisk4">Kontakt</Button>
        </Linkii>
      </Belt>
    </Navigation>
  );
}

export default Nav;
